import React, { useEffect, useRef, useState } from 'react';
import { strings } from '../constants/strings';
import { colors } from '../constants/colors';
import { TrendingUp } from 'lucide-react';

const Outcomes = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section className="section-padding outcomes-section" ref={sectionRef}>
      <div className="outcomes-background">
        <div className="gradient-blob blob-1"></div>
        <div className="gradient-blob blob-2"></div>
      </div>
      
      <div className="container">
        <div className={`section-header ${isVisible ? 'fade-in-up' : ''}`}>
          <TrendingUp size={40} style={{ color: colors.accent }} />
          <h2 className="section-title">{strings.outcomes.title}</h2>
        </div>
        
        <div className="outcomes-grid">
          {strings.outcomes.metrics.map((metric, index) => (
            <div 
              key={index} 
              className={`outcome-card ${isVisible ? 'scale-in' : ''}`}
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="outcome-number">{metric.number}</div>
              <div className="outcome-text">{metric.text}</div>
              <div className="outcome-accent-line"></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Outcomes;
